export class SlidingWindowLimiter {
  constructor(limit = 5, windowMs = 10000) {
    if (!Number.isInteger(limit) || limit < 1) throw new TypeError('limit must be a positive integer');
    if (!Number.isFinite(windowMs) || windowMs <= 0) throw new TypeError('windowMs must be positive');
    this.limit = limit;
    this.windowMs = windowMs;
    this.timestamps = [];
  }

  attempt(now = Date.now()) {
    const threshold = now - this.windowMs;
    this.timestamps = this.timestamps.filter((timestamp) => timestamp > threshold);
    if (this.timestamps.length >= this.limit) return false;
    this.timestamps.push(now);
    return true;
  }

  reset() {
    this.timestamps = [];
  }
}

function showThrottleNotice(form) {
  let status = form.querySelector('[data-rauda-throttle-status]');
  if (!status) {
    status = document.createElement('p');
    status.dataset.raudaThrottleStatus = '';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.style.cssText = 'margin:12px 0;color:inherit;font-size:13px;line-height:1.4;';
    form.append(status);
  }
  status.textContent = 'Zu viele Aktionen in kurzer Zeit. Bitte warte zehn Sekunden und versuche es erneut.';
}

if (typeof document !== 'undefined') {
  const limiters = new WeakMap();

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || form.method.toLowerCase() === 'get') return;
      if (!form.matches('.email-signup__form, .contact-form__form, [data-rauda-throttle]')) return;

      let limiter = limiters.get(form);
      if (!limiter) {
        limiter = new SlidingWindowLimiter(5, 10000);
        limiters.set(form, limiter);
      }

      if (limiter.attempt()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      showThrottleNotice(form);
    },
    true
  );
}
